export default {
  title: 'Factory Management',
  addFactory: 'Add Factory',
  factoryInfo: 'Factory Info',
  factoryInfoPlaceholder: 'Enter factory no. or name',
  langRequired: 'Please select language',
  factoryNo: 'Factory No.',
  factoryName: 'Factory Name',
  factoryAddress: 'Factory Address',
  addModal: 'Add Factory',
  editModal: 'Edit Factory',
  factoryNoPlaceholder: 'Enter factory no.',
  factoryNamePlaceholder: 'Enter factory name',
  factoryAddressPlaceholder: 'Enter factory address',
  requiredFactoryNo: 'Please enter factory no.',
  requiredFactoryName: 'Please enter factory name',
};
